import React, { useEffect, useState } from 'react';
import { Button, LayerBottom, Select } from 'components'
import useApp from 'hooks/useApp'
import stationImg from 'images/tmp_inspection_station.png'
import styles from './index.module.css'
import DetailTip from 'views/mydata/common/DetailTip';

const MyCarInspection = () => {

	const App = useApp()
	const [showLayer, setShowLayer] = useState(false)
	const [showDetail, setShowDetail] = useState(false)

	const closeLayer = () => {
		setShowLayer(false)
	}

	const openLayer = () => {
		setShowLayer(true)
	}

	const closeDetail = () => {
		setShowDetail(false)
	}

	const openDetail = () => {
		setShowDetail(true)
	}

	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: <i className="icon icon_arrow_back" onClick={App.goBack} />,
			right: ""
		})

		App.setShowNav(false)
		App.setMainClass("white")
	}, [])

	return (
		<div className="page">
			<div className="padding pb_20">
				<div className="flex-align_center">
					<h3>자동차 검사소 찾기</h3>
					<i className="icon icon_question ml_10" onClick={openDetail} />
				</div>

				<p className="guide-title mt_40">지역 선택</p>
				<Select title="검사소 지역 선택" className="mt_10" selected={1} data={[
					{ key: "서울특별시", value: 0 },
					{ key: "경기도", value: 1 },
					{ key: "전라북도", value: 2 },
					{ key: "경상남도", value: 3 },
					{ key: "광주광역시", value: 4 },
					{ key: "강원도", value: 5 },
					{ key: "대전광역시", value: 6 },
					{ key: "대구광역시", value: 7 },
					{ key: "울산광역시", value: 8 },
				]} onSelect={(key, value) => {
					console.log(key, value)
				}}>
				</Select>

				<div className="img-box mt_40" style={{ maxHeight: "40rem" }}>
					<img src={stationImg} alt="" />
				</div>
			</div>

			<ul className={`${styles["inspection-list"]} list-bg`}>
				<li onClick={openLayer}>
					<div className={`${styles.recommend} mb_10`}>
						<i className="tag tag-blue">추천</i>
						<span className="ml_10">차고지랑 같은 동네</span>
					</div>
					<p>늘푸른 자동차 공업사</p>
					<div className={`${styles["address-info"]} mt_10`}>
						<p>경기도 부천시 부흥로 210 (중동) <i className="icon icon_copy ml_10" /></p>
						<p>운영시간 : 05:30 ~ 15:30</p>
					</div>
					<span className={`${styles.call} mt_10`}>054-439-3124</span>
				</li>
				<li>
					<p>늘푸른 자동차 공업사</p>
					<div className={`${styles["address-info"]} mt_10`}>
						<p>경기도 부천시 부흥로 210 (중동) <i className="icon icon_copy ml_10" /></p>
						<p>운영시간 : 05:30 ~ 15:30</p>
					</div>
					<span className={`${styles.call} mt_10`}>054-439-3124</span>
				</li>
				<li>
					<p>늘푸른 자동차 공업사</p>
					<div className={`${styles["address-info"]} mt_10`}>
						<p>경기도 부천시 부흥로 210 (중동) <i className="icon icon_copy ml_10" /></p>
						<p>운영시간 : 05:30 ~ 15:30</p>
					</div>
					<span className={`${styles.call} mt_10`}>054-439-3124</span>
				</li>
				<li>
					<p>늘푸른 자동차 공업사</p>
					<div className={`${styles["address-info"]} mt_10`}>
						<p>경기도 부천시 부흥로 210 (중동) <i className="icon icon_copy ml_10" /></p>
						<p>운영시간 : 05:30 ~ 15:30</p>
					</div>
					<span className={`${styles.call} mt_10`}>054-439-3124</span>
				</li>
				<li>
					<p>늘푸른 자동차 공업사</p>
					<div className={`${styles["address-info"]} mt_10`}>
						<p>경기도 부천시 부흥로 210 (중동) <i className="icon icon_copy ml_10" /></p>
						<p>운영시간 : 05:30 ~ 15:30</p>
					</div>
					<span className={`${styles.call} mt_10`}>054-439-3124</span>
				</li>
			</ul>

			<InspectionStation show={showLayer} closeLayer={closeLayer} />
			<DetailTip show={showDetail} closeLayer={closeDetail} title="자동차 검사소 찾기">
				자동차 검사소 찾기는 공공데이터포털의 전국자동차 검사소 표준데이터 api를 활용하여 제공하고 있어요.
				데이터의 업데이트 주기 등으로 인해 실제 정보와 다를 수 있으니 방문 전에 전화로 확인하시고 방문하시기를 바랍니다.
			</DetailTip>
		</div>
	)
}

const InspectionStation = ({ show, closeLayer }) => {
	return (
		<LayerBottom title="검사소 정보" show={show} closeLayer={closeLayer}>
			<div className="layer-text">
				<div className={styles["inspection-list"]}>
					<div className={`${styles.recommend} mb_10`}>
						<i className="tag tag-blue">추천</i>
						<span className="ml_10">차고지랑 같은 동네</span>
					</div>
					<p>늘푸른 자동차 공업사</p>
					<div className={`${styles["address-info"]} mt_10`}>
						<p>경기도 부천시 부흥로 210 (중동) <i className="icon icon_copy ml_10" /></p>
						<p>운영시간 : 05:30 ~ 15:30</p>
					</div>
					<span className={`${styles.call} mt_10`}>054-439-3124</span>
				</div>
				<ul className="my-info-box mt_40">
					<li>
						<span>검사진로수</span>
						<span>3개</span>
					</li>
					<li>
						<span>검사기술인력수</span>
						<span>5명</span>
					</li>
				</ul>
				<ul className="list-item mt_40" style={{ fontSize: "1.4rem" }}>
					<li>
						<span>신규검사</span>
						<span>가능</span>
					</li>
					<li>
						<span>정기검사</span>
						<span>가능</span>
					</li>
					<li>
						<span>수리검사</span>
						<span>가능</span>
					</li>
					<li>
						<span>배출가스검사</span>
						<span>불가능</span>
					</li>
					<li>
						<span>튜닝검사</span>
						<span>가능</span>
					</li>
					<li>
						<span>임시검사</span>
						<span>-</span>
					</li>
					<li>
						<span>택시미터검사</span>
						<span>불가능</span>
					</li>
				</ul>
			</div>
		</LayerBottom>
	)
}

export default MyCarInspection